'use client';

import React, { useState } from 'react';
import ErrorModal, { ErroModalInterface } from './ErrorModal';
import { useAppDispatch, useAppSelector } from '@/hotdesk-ui/hooks/hook';
import { RootState } from '@/hotdesk-ui/store/store';
import { setIsOpenErrorModal } from '@/hotdesk-ui/store/slices/error.slice';
const ErroModalClient: React.FC<ErroModalInterface> = ({
  show
}) => {
  const isError = useAppSelector((state: RootState) => state.errorModal.isOpenErrorModal);
  const dispatch = useAppDispatch();
  const handleClose = () => {
    dispatch(setIsOpenErrorModal(false));
  };
  return <ErrorModal show={isError} handleClose={handleClose} data-sentry-element="ErrorModal" data-sentry-component="ErroModalClient" data-sentry-source-file="ErrorModalClient.tsx"></ErrorModal>;
};
export default ErroModalClient;